<template>
  <q-dialog :visible="isVisible" :title="title" width="800px" :innerScroll="false" :showFooter="false" @close="onCancel">
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="80px">
      <el-table v-loading="loading" :data="tableData.list" height="300px" border style="width: 100%">
        <el-table-column prop="storeName" label="适用店铺" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deliveryCycle" label="发货周期" width="100"></el-table-column>
        <el-table-column prop="updatedBy" label="更新人" width="100"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" width="180"></el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
        ></el-pagination>
      </div>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "调整记录";
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      rules: {},
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      currencyForm: {
        pageSize: 30,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "Y",
        groupAttr: "",
      },
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.pageNum = this.tableData.pageNum;
      currencyForm.pageSize = this.tableData.pageSize;
      currencyForm.queryMatch = [
        {
          attributeName: "goodsCode",
          val: this.rowData.goodsCode,
          op: '=',
        },
        {
          attributeName: "originalDataId",
          val: this.rowData.dataId,
          op: "=",
        },
      ];
      currencyForm.reportCode = "goodsDeliverCycleModifySale";
      axios
        .post(`/ec-pc-api/custom/reports/data/goodsDeliverCycleModifySale`, currencyForm)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>

>>> .el-form-item {
  margin-bottom: 0px
}

>>> .el-form .el-select {
  width: 100px
}

>>> .el-pagination__editor.el-input {
    width: 50px;
}
</style>
